import moment from 'moment'
import React from 'react'
import './DialogBubble.scss'
import CheckMessage from './partials/CheckMessage'
import DeletedMessageMarker from './partials/DeletedMessageMarker'

const DialogBubble = (props) => {
  return (
    <div id={props.message.messageId} className="dialogBubble">
      <div className={props.isProfessional ? 'message own' : 'message'}>
        {props.message.deletedAt && (
          <div className="deletedMessageMarker">
            <DeletedMessageMarker />
          </div>
        )}
        {!!props.message.auto && <div style={{ color: '#01A8E7', fontSize: '12px' }}> Mensaje automático </div>}

        <div className="component-chatListItem">{props.children}</div>

        <div className="bubbleFooter">
          <span className="date">{moment(props.message.createdAt).format('DD MMM  HH:mm ')}</span>
          <CheckMessage status={props.message.status} />
        </div>
      </div>
    </div>
  )
}

export default DialogBubble
